module.exports = function (document) {
  let mouseDownTarget
  document.addEventListener('mousedown', event => {
    mouseDownTarget = event.target
  }, true)
  document.addEventListener('click', event => {
    const target = event.target
    if (event.detail && target.matches &&
        target.matches('.el-dialog__wrapper, .el-message-box__wrapper') &&
        mouseDownTarget && mouseDownTarget !== target && target.contains(mouseDownTarget)) {
      event.stopImmediatePropagation()
    }
    mouseDownTarget = null
  }, true)
}



// WEBPACK FOOTER //
// ./src/utils/dialog-drag-selection.js